import React from "react";
import { TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import Page from "components/ui/Page/Page";
import DatePicker from "components/ui/DatePicker/DatePicker";
import { FormFieldContainer } from "components/ui/FormField";
import {
    FormContainer,
    inputStyles,
} from "components/ui/FormField/FormFieldContainer";

/**
 * @description This component renders the "Eligibility Check" step of the enrollment process.
 * @param {Object} formData - The form data for the eligibility check step.
 * @param {Function} onChange - The function to handle form field changes.
 * @param {Function} onSubmit - The function to handle form submission.
 * @param {boolean} isSubmitting - Indicates if the form is currently being submitted.
 * @returns {JSX.Element} The rendered component.
 */
const EligibilityForm = ({ formData, onChange, onSubmit, isSubmitting }) => {

    const handleChange = (e) => {
        const { name, value } = e.target;
        onChange("eligibility", name, value);
    };

    const handleDateChange = (date) => {
        onChange("eligibility", "dateOfBirth", date);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };

    return (
        <Page
            heading="Let's Check Your Eligibility"
            subHeading="We need some basic information to check your eligibility."
        >
            <FormContainer>
                {/* Section 1: Full Name (Uses a Grid layout for side-by-side inputs) */}
                <FormFieldContainer
                    heading="Full Name"
                    required
                    subHeading="Please enter the required fields exactly as they are written on your health insurance card. (ex. John H Doe may have a first name of John, or John H)"
                    fields={[
                        <TextField
                            fullWidth
                            name="firstName"
                            placeholder="First Name"
                            value={formData.firstName}
                            onChange={handleChange}
                            inputProps={{
                                autocomplete: "off",
                            }}
                            sx={inputStyles()}
                        />,
                        <TextField
                            fullWidth
                            name="lastName"
                            placeholder="Last Name"
                            value={formData.lastName}
                            onChange={handleChange}
                            inputProps={{
                                autocomplete: "off",
                            }}
                            sx={inputStyles()}
                        />,
                    ]}
                />

                {/* Section 2: Date of Birth (Uses a single input with error handling) */}
                <FormFieldContainer
                    heading="Date of Birth (MM/DD/YYYY)"
                    required
                    fields={[
                        <DatePicker
                            format="MM/DD/YYYY"
                            value={formData.dateOfBirth}
                            onChange={handleDateChange}
                            inputSx={inputStyles()}
                        />,
                    ]}
                />

                {/* Centered Button */}
                <LoadingButton
                    onClick={handleSubmit}
                    variant="contained"
                    loading={isSubmitting}
                    disabled={
                        !formData.firstName?.trim() ||
                        !formData.dateOfBirth
                    }
                    sx={{
                        width: "100%",
                        maxWidth: "594px",
                        alignSelf: "center",
                    }}
                >
                    CHECK ELIGIBILITY
                </LoadingButton>
            </FormContainer>
        </Page>
    );
};

export default EligibilityForm;
